import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'influencerNetworks',
  urlRoot: '/influencer_networks'
})
